import React, { useState } from "react";

function RelatedDetails({
  title,
  price,
  SlideImages: initialSlideImages,
  negotiable,
  engin,
  fuel,
  location,
  description,
  model,
  year,
  mileage,
  transmission,
  condition,
  color,
  features,
  contact,
  MainImage,
  brand,
}) {
  const [currentMainImage, setCurrentMainImage] = useState(MainImage);
  const [slideImages, setSlideImages] = useState(initialSlideImages);

  //slide image change function
  const handleImageClick = (clickedImage, index) => {
    const newSlideImages = [...slideImages];
    newSlideImages[index] = currentMainImage;
    setSlideImages(newSlideImages);
    setCurrentMainImage(clickedImage);
  };

  return (
    <div className="h-full w-[100%] lg:flex lg:px-[4%] md:px-[2%] px-[1%]  gap-10 py-10">
      {/* Image Section */}
      <div className="lg:w-1/2 flex flex-col items-center gap-6">
        <div className=" w-[400px] h-[300px] border rounded-lg overflow-hidden">
          <img
            src={currentMainImage}
            alt={title}
            className="w-full h-full object-contain"
          />
        </div>

        <div className=" flex gap-4 flex-wrap justify-center">
          {slideImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${title}-${index}`}
              className="w-[67px] h-[60px] object-cover border rounded-md shadow-md hover:opacity-75 cursor-pointer"
              onClick={() => handleImageClick(image, index)}
            />
          ))}
        </div>
      </div>

      {/* Details Section */}
      <div className="lg:w-[40%] md:w-[40%] w-[100%]  flex flex-col gap-[5px] text-[14px] lg:px-[0px] md:[0px] px-[5px] lg:pt-0 md:pt-0 pt-10">
        <p className="font-bold text-xl"> {title}</p>
        <p>Model: {model}</p>
        <p>Condition: {condition}</p>
        <p>Gear Type: {transmission}</p>
        <p>Fuel Type: {fuel}</p>
        <p>Year: {year}</p>
        <p>Engine: {engin}</p>
        <p>Mileage: {mileage}</p>
        <p>Color: {color}</p>
        <p>
          Features <span className="block">{features}</span>
        </p>

        <p>
          Description <span className="block">{description}</span>
        </p>
        <p>Address: {location}</p>
        <p className="font-bold">Price: {price}</p>
        <p className=" text-primary font-bold text-[16px]">{negotiable ? "Negotiable" : ""}</p>
        <p>Contact: {contact}</p>
      </div>
    </div>
  );
}

export default RelatedDetails;
